import './bootstrap';
import './optional-media/wollimedia-bridge.js';
import { installFredUI } from '@wolliware/fredui';
import { installWolliPeople } from '@wolliware/wollipeople';
import registerWolliMediaClient from '@wolliware/wollimedia-client/source';
import { registerFeaturedMediaFields } from './admin/featured-media-fields';
import { registerSimpleFeaturedMediaFields } from './admin/simple-featured-media-field';
import { registerAdminTagSelectors } from './admin/tag-selectors';
import { registerContentFormSync } from './admin/content-form-sync';
import { createDraftRecovery } from './admin/draft-recovery';
import Alpine from 'alpinejs';

window.Alpine = Alpine;
installFredUI({ http: true, form: true, sortableList: true });
void installWolliPeople();
registerWolliMediaClient(Alpine);
registerAdminTagSelectors(Alpine);
Alpine.data('draftRecovery', createDraftRecovery);

// Module scripts run in document order, all before `DOMContentLoaded` fires -
// deferring Alpine.start() to that event (rather than calling it immediately
// here) lets page-specific widget scripts placed later in the document (e.g.
// the-fred-playa's, which registers Alpine.data('theFredPlaya', ...) via an
// alpine:init listener) finish executing and register themselves first.
// Calling Alpine.start() immediately here would fire that one-time event
// before such later scripts have had a chance to attach their listener.
document.addEventListener('DOMContentLoaded', () => Alpine.start());

registerFeaturedMediaFields();
registerSimpleFeaturedMediaFields();
registerContentFormSync();
